function isMultiple(value) {
    return Array.isArray(value);
}
function renderLabel({ label, render }) {
    if (render)
        return render(label);
    return label;
}
function buildOptionsTree(options, idsMap) {
    function buildOption(id) {
        const { items, childIds } = idsMap;
        const data = { ...items[id] };
        const childs = childIds[id];
        if (childs)
            data.children = childs.map(buildOption);
        return data;
    }
    return options.reduce((acc, { id, parentId }) => (parentId ? acc : [...acc, buildOption(id)]), []);
}
function mapById(options) {
    return options.reduce((acc, item) => {
        const { items, childIds } = acc;
        const { id, parentId } = item;
        items[id] = item;
        if (parentId) {
            if (!childIds[parentId])
                childIds[parentId] = [];
            childIds[parentId].push(id);
        }
        return acc;
    }, {
        items: {},
        childIds: {},
    });
}

export { buildOptionsTree, isMultiple, mapById, renderLabel };
